/** Dialog segments under a standards management base (`/standards-management` or a storefront standards tab). */
export const STANDARDS_DIALOG_SEGMENTS = {
  createFolder: "create-folder",
  warehouseInventory: "warehouse-inventory",
  moveTo: "move-to",
  delete: "delete",
  addProducts: "add-products",
  replaceProduct: "replace-product",
} as const;

/** Appends every standards dialog segment to a route base, for `allowedOverlayPath`. */
export const standardsDialogOverlayPaths = (base: string): string[] =>
  Object.values(STANDARDS_DIALOG_SEGMENTS).map(
    (segment) => `${base}/${segment}`,
  );
